import {
    GET_LOGS_SKU, GET_PRICE_ERRORS, RESOLVE_SINGLE_LOGS_SKU,

} from './logs.type';

export const getLogsSku = (data) => {
    return {
        type: GET_LOGS_SKU,
        payload: data,
    };
};

export const resolveLogsSku = (data, id) => {
    return {
        type: RESOLVE_SINGLE_LOGS_SKU,
        payload: {
            data,
            id
        },
    };
};

export const getPriceErrors = (params) => {
    return{
        type: GET_PRICE_ERRORS,
        payload: { params },
    }
}